export default "__VITE_ASSET__Q8dEHlzn__"